module.exports = "<div class=\"emptystate\" >\n  \n    <img src=\"assets/images/emptystate.png\">\n</div>"